import { Error } from '../interface/upplm.common.interface';

export class ClientKeyMatchRequest {
    clientKey: string;
    placardIdList: Array<string>;
}
export class ClientKeyMatchResponse {
    clientKeymatch: boolean;
    placardId: string;
    placardStatus: string;
    passedPickupStartDate: boolean;
    address: Array<Address>
    errors?: Array<Error>;
}

export class AddClientKeyRequest {
    clientKey: string;
}

export class AddClientKeyResponse {
    clientKey: string;
    placardId: string;
    updateResult: boolean;
    errors?: Array<Error>;
}

export class Address {
    cityTown: string;
    stateProvince:  string;
    countryCode: string;
    postalCode: string;
    addressLine1:  string;
}



